import { mapState } from "vuex"

export default {
  data() {
    return {
      selecting: false,
      selected: [],
    }
  },
  methods: {
    toggleItem(item) {
      if (!this.selecting) return;
      const id = item.uid || item.id || item.sku
      if (!id) return;

      if (!this.selected.includes(id)) {
        this.selected.push(id)
      } else {
        this.selected.splice(
          this.selected.indexOf(id),
          1,
        )
      }
    },
  },
  computed: {
    ...mapState({
      hasModal: state => state.modal,
    }),

    showButton() {
      return this.selecting && this.selected.length
    },
  },
  watch: {
    hasModal(val) {
      if (!val && this.selecting) {
        // this.selecting = false
        this.selected = []
      }
    },
    selecting(val) {
      if (!val) {
        this.selected = []
      }
    },
    selected(val) {
      console.log("selected: ", val)
    },
  },
}
